
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
import { setFundsPassword } from '../service/getdata'
export default {
data(){
return{
show:false,
msg:"",
oldpwd: "", //旧密码
newpwd: "", //新密码
subpwd: "", //确认密码
input_type: "password",
input_type2: "password",
input_type3: "password",
}
},
components:{
XHeader,
Toast
},
created(){
this.SETTOKEN()
},
computed:{
...mapState(['token'])
},
methods:{
...mapMutations(['SETTOKEN']),
save(){
var that = this



if(this.newpwd==""){
this.sendMsg(this.$t("请输入新密码"))
}else if(this.newpwd.length!=6){
this.sendMsg(this.$t("请输入6位数新密码"))
}else if(this.subpwd==""){
this.sendMsg(this.$t("请再次输入新密码"))
}else if(this.subpwd != this.newpwd){
this.sendMsg(this.$t("请确认两次密码输入一致"))
}else{
this.$Loading();
let params = {
token: this.token,

newpwd: this.newpwd,
subpwd: this.subpwd
}
setFundsPassword(params).then(function(res){
var res = res.data;
that.$Loading.close()

if(res.status=='1'){
that.$vux.alert.show({
title: that.$t("提示"),
content: res.message,
buttonText: that.$t("确定"),
onHide:function(){
that.$router.go("-1")

}
})
}else if(res.status=='-1'){

}else{
that.sendMsg(res.message)
}
}.bind(this),function(error){
that.$Loading.close()
that.sendMsg(that.$t("提交失败"))
})
}
},

sendMsg(content) {
this.msg = content;
this.show = true;
}
}
}



// WEBPACK FOOTER //
// ./src/pages/setFundsPassword.vue